
import { Network } from '@wren/shared';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { scale } from '../../util/scale';
import SlideOut from '../animation/SlideOut';
import Button from '../buttons/Button';
import { projectSubHeader } from './ProjectRenderer';
import UpdatePreview from './UpdatePreview';

const container = scale({
  maxWidth: '750px',
});

const fadeStyle = (rgb) =>
  scale({
    position: 'absolute',
    zIndex: 2,
    background: [
      `linear-gradient(rgba(${rgb},0) 0%, rgba(${rgb},1) 70%, rgba(${rgb},1) 100%)`,
      `linear-gradient(rgba(${rgb},0) 0%, rgba(${rgb},1) 60%, rgba(${rgb},1) 100%)`,
    ],
    height: 'calc(100% + 8px)',
    width: 'calc(100% + 8px)', // add a bit extra width
    left: -4, // extra width accomodates box shadow on white card style
    bottom: -8,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  });

const UpdatesTimeline = ({
  slug,
  backgroundColor = '255, 255, 255',
  hasTitle = false,
}) => {
  const [updates, setUpdates] = useState([]);
  const [showMoreUpdates, setShowMoreUpdates] = useState(false);

  useEffect(() => {
    const getUpdates = async () => {
      const [response, responseBody] = await Network.get(`blog/posts`, {
        tagsAll: `${slug},project-update`,
      });

      if (response.ok) {
        setUpdates(responseBody.posts);
      }
    };
    getUpdates();
  }, [slug]);

  if (updates.length === 0) return null;
  return (
    <div css={container}>
      {hasTitle && updates.length > 0 && (
        <h2 css={projectSubHeader} id="updates">
          Project updates
        </h2>
      )}
      {updates.length > 0 && <UpdatePreview isMostRecent update={updates[0]} />}
      {updates.length > 1 && <UpdatePreview update={updates[1]} />}
      {updates.length > 2 && !showMoreUpdates && (
        <div css={{ position: 'relative' }}>
          <UpdatePreview update={updates[2]} />
          <div css={fadeStyle(backgroundColor)}>
            <div css={{ width: 200, marginBottom: 32 }}>
              <Button
                size="medium"
                type="grayUppercase"
                text="Show older updates"
                onClickFn={() => setShowMoreUpdates(!showMoreUpdates)}
              />
            </div>
          </div>
        </div>
      )}
      <SlideOut>
        {showMoreUpdates && (
          <div>
            {updates.slice(2).map((update) => (
              <UpdatePreview update={update} />
            ))}
            <div css={{ width: 200, margin: 'auto' }}>
              <Button
                size="medium"
                type="grayUppercase"
                text="Hide older updates"
                onClickFn={() => setShowMoreUpdates(!showMoreUpdates)}
              />
            </div>
          </div>
        )}
      </SlideOut>
    </div>
  );
};

UpdatesTimeline.propTypes = {
  projectId: PropTypes.number,
};

UpdatesTimeline.defaultProps = {
  projectId: 10,
};

export default UpdatesTimeline;
